import Vue from 'vue'
import {
  GIFT_REVIEW_APPLY_TYPES,
  GIFT_APPLICATION_STATE_TYPES,
  GIFT_REVIEW_STATE_TYPES,
  PERMISSION_TYPE
} from '@/utils/constants'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      typeOptions: this.getTypeOptions(),
      stateOptions: this.getStateOptions()
    }
  },
  computed: {
    ...mapGetters('app', ['hasPermission']),
    canAdd() {
      return this.hasPermission(PERMISSION_TYPE.GiftsApplicationsProcess)
    }
  },
  methods: {
    canModify(item) {
      if (!this.hasPermission(PERMISSION_TYPE.GiftsApplicationsProcess)) {
        return false
      }

      if (!this.isOperator(item, this.$store.getters.empCode)) {
        return false
      }

      return item.state === GIFT_APPLICATION_STATE_TYPES.REJECT
    },
    canSubmit(item) {
      if (!this.hasPermission(PERMISSION_TYPE.GiftsApplicationsProcess)) {
        return false
      }

      if (!this.isOperator(item, this.$store.getters.empCode)) {
        return false
      }

      return item.state === GIFT_APPLICATION_STATE_TYPES.REJECT
    },
    canReview(item) {
      if (
        !this.hasPermission(PERMISSION_TYPE.GiftsReviewsProcess) ||
        item === null
      ) {
        return false
      }

      return item.state === GIFT_REVIEW_STATE_TYPES.PENDING
    },
    canVoid(item) {
      if (
        !this.hasPermission(PERMISSION_TYPE.GiftsReviewsProcess) ||
        item === null
      ) {
        return false
      }

      return item.state === GIFT_REVIEW_STATE_TYPES.AUDIT
    },
    canCancel(item) {
      if (
        !this.hasPermission(PERMISSION_TYPE.GiftsReviewsCancel) ||
        item === null
      ) {
        return false
      }

      return item.state === GIFT_REVIEW_STATE_TYPES.AUDIT
    },
    canClone(item) {
      if (
        !this.hasPermission(PERMISSION_TYPE.GiftsApplicationsProcess) ||
        item === null
      ) {
        return false
      }

      if (!this.isOperator(item, this.$store.getters.empCode)) {
        return false
      }

      return item.state === GIFT_REVIEW_STATE_TYPES.REJECT
    },
    canReturn(item) {
      if (
        !this.hasPermission(PERMISSION_TYPE.GiftsApplicationsProcess) ||
        item === null
      ) {
        return false
      }

      if (item.state !== GIFT_REVIEW_STATE_TYPES.AUDIT) {
        return false
      }

      return !item.is_return_pending
    },
    canPrint(item) {
      if (
        !this.hasPermission(PERMISSION_TYPE.GiftsApplicationsProcess) ||
        item === null
      ) {
        return false
      }

      return item.state === GIFT_REVIEW_STATE_TYPES.PENDING
    },

    isSales(item, employee) {
      return item.sales_code === employee
    },
    isOperator(item, employee) {
      if (item === null) {
        return false
      }
      return item.operator_code === employee
    },

    isFit(item) {
      if (item === null) {
        return false
      }
      return item.apply_type === GIFT_REVIEW_APPLY_TYPES.FIT
    },
    isGroup(item) {
      if (item === null) {
        return false
      }
      return item.apply_type === GIFT_REVIEW_APPLY_TYPES.GROUP
    },

    isAudit(item) {
      if (item === null) {
        return false
      }
      return item.state === GIFT_REVIEW_STATE_TYPES.AUDIT
    },
    isRejected(item) {
      return item === null
        ? false
        : item.state === GIFT_REVIEW_STATE_TYPES.REJECT
    },
    isVoid(item) {
      if (item === null) {
        return false
      }
      return item.state === GIFT_REVIEW_STATE_TYPES.VOID
    },

    typeEnabled(type) {
      return (
        type === GIFT_REVIEW_APPLY_TYPES.FIT ||
        type === GIFT_REVIEW_APPLY_TYPES.GROUP ||
        (type === GIFT_REVIEW_APPLY_TYPES.REPURCHASE &&
          this.hasPermission(PERMISSION_TYPE.GiftsPostsProcess))
      )
    },
    getTypeOptions() {
      return Object.values(GIFT_REVIEW_APPLY_TYPES).map(type => ({
        value: type,
        name: this.applyTypeName(type)
      }))
    },
    getStateOptions() {
      return Object.values(GIFT_REVIEW_STATE_TYPES).map(type => ({
        value: type,
        name: this.stateName(type)
      }))
    },
    applyTypeName(type) {
      return Vue.i18n.translate(`attributes.gift_application_${type}`)
    },
    stateName(state) {
      return Vue.i18n.translate(`attributes.gift_application_${state}`)
    },
    returnState(review) {
      if (review.state !== GIFT_REVIEW_STATE_TYPES.AUDIT) {
        return ''
      }

      return review.is_return_pending ? '(申請退回中)' : ''
    }
  }
}
